export default "__VITE_ASSET__BzPwY2Do__"